/** The style bar's picture tools: crop (as a double click does), and the whole picture again. */
import { Show, type JSX } from "solid-js";
import { useApp } from "../../../../app/context";
import type { Bar } from "./bar";

/** Crop and Whole picture. */
export function PictureTools(props: { bar: Bar }): JSX.Element {
  const { board } = useApp();
  return (
    <>
      <button type="button" data-board-action="crop" title="Crop (or double-click the picture)" onClick={() => board.selected()[0] && board.startCrop(board.selected()[0]!)}>
        Crop
      </button>
      <Show when={props.bar.value("crop")}>
        <button type="button" data-board-action="uncrop" title="Show the whole picture again" onClick={() => void board.uncrop()}>
          Whole picture
        </button>
      </Show>
    </>
  );
}
